var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.taskItemData.txtTotal)?_c('div',{staticStyle:{"padding-bottom":"20px","text-align":"left","font-size":"12pt","font-family":"宋体"}},[_vm._v(" "+_vm._s(_vm.taskItemData.txtTotal)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }